import './SliderClassic.css';
import { Avatar } from '../../../../components/Avatar/Avatar';
import arrowClassic from '../../../../images/arrowClassic.png';

export const SliderClassic = () => {
    return (
        <div className="slider-classic">
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <Avatar />
            <img src={arrowClassic} alt="" className="slider-classic__choice-arrow" />
            <div className="slider-classic__choice-container"></div>
        </div>
    );
};
